import React from 'react'

import { ThemeProvider } from '@mui/material'
import { getColorMode, getTheme } from 'themes'

import { FilterBarProps } from '.'

import Box from 'components_new/atoms/Box'
import Chip from 'components_new/atoms/Chip'
import { useBackgroundColor } from 'redux/hooks/Customization'

import { useTranslation } from 'language/translator'

const Mobile = (props: FilterBarProps) => {
  const { readOnly, filter, setFilter = () => {}, sx } = props
  const bgcolor = useBackgroundColor()

  const { t } = useTranslation()

  const theme = getTheme(bgcolor ? getColorMode(bgcolor) : 'light', null, {
    responsive: true
  })

  // success
  return filter.length > 0 ? (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 1,
          pr: 1,
          overflowX: 'auto',
          WebkitMaskImage:
            'linear-gradient(to right, rgb(0, 0, 0) 95%, rgba(0, 0, 0, 0) 100%)',
          ...sx
        }}
      >
        {/*-- left bleed --*/}
        <Box sx={{ minWidth: '8px', height: '100%' }} />

        {filter.map((f1, i) => (
          <Chip
            key={i}
            color="primary"
            label={
              (f1.display_value ?? f1.value) === null
                ? t('global', 'missing_value')
                : f1.display_value ?? f1.value
            }
            onDelete={
              readOnly
                ? undefined
                : () =>
                    setFilter(
                      filter.filter(
                        (f2) =>
                          f2.attribute !== f1.attribute || f2.value !== f1.value
                      )
                    )
            }
            size="medium"
          />
        ))}
      </Box>
    </ThemeProvider>
  ) : null
}

export default Mobile
